import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, normalizeStyle as _normalizeStyle, unref as _unref } from "vue"

const _hoisted_1 = { class: "deleted" }

import {computed, ref, watch} from "vue";
import InsuranceExportBlank, {sortInsuranceExportBlank} from "@/shared/model/InsuranceExportBlank";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";
import SogCardActions from "@/shared/ui/SogCardActions.vue";
import {useShoppingCartStore} from "@/modules/ShoppingCart/store";
import SogCard from "@/shared/ui/SogCard.vue";
import SogFlexRow from "@/shared/ui/SogFlexRow.vue";
import SogCardTitle from "@/shared/ui/SogCardTitle.vue";
import {useDisplay} from "vuetify";

interface Props {
  exportBlanks: InsuranceExportBlank[],
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SelectExportBlanksComponent',
  props: {
    exportBlanks: {}
  },
  setup(__props: any) {

const props = __props

const {mobile} = useDisplay()

const _shoppingCartStore = useShoppingCartStore();
const _storeExportBlank = ref<InsuranceExportBlank[]>([])

function onAddExportBlank(blank: InsuranceExportBlank) {
  if(blank.isInShoppingCart===true) return;
  _shoppingCartStore.addInsuranceExportBlank(blank)
  //_storeExportBlank.value = _storeExportBlank.value.filter(t => t.id != blank.id)
}

function onRemoveExportBlank(blank: InsuranceExportBlank) {
  _shoppingCartStore.removeInsuranceExportBlank(blank)
  _storeExportBlank.value = sortInsuranceExportBlank([..._storeExportBlank.value, blank])
}

watch((props), () => {
  _storeExportBlank.value = [...props.exportBlanks]
}, {immediate: true})

const _style = computed(()=>{
  if(mobile.value){
    return "";
  }
  return "width: 49%";
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogFlexRow, null, {
    default: _withCtx(() => [
      _createVNode(SogCard, {
        style: _normalizeStyle(_style.value)
      }, {
        default: _withCtx(() => [
          _createVNode(SogCardTitle, null, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createTextVNode(" Lager ", -1)
            ]))]),
            _: 1
          }),
          _createVNode(SogCardActions, { "is-toolbar": true }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_storeExportBlank.value, (blank) => {
                return (_openBlock(), _createBlock(SogCardActionButton, {
                  key: blank,
                  onClick: ($event: any) => (onAddExportBlank(blank))
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("div", _hoisted_1, [
                      _createTextVNode(_toDisplayString(blank.insuranceNumber), 1),
                      _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
                      _createTextVNode(_toDisplayString(blank.blankNumber), 1)
                    ], 512), [
                      [_vShow, blank.isInShoppingCart]
                    ]),
                    _withDirectives(_createElementVNode("div", null, [
                      _createTextVNode(_toDisplayString(blank.insuranceNumber), 1),
                      _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
                      _createTextVNode(_toDisplayString(blank.blankNumber), 1)
                    ], 512), [
                      [_vShow, !blank.isInShoppingCart]
                    ])
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["style"]),
      _createVNode(SogCard, {
        style: _normalizeStyle(_style.value)
      }, {
        default: _withCtx(() => [
          _createVNode(SogCardTitle, null, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createTextVNode("Ausgewählt", -1)
            ]))]),
            _: 1
          }),
          _createVNode(SogCardActions, {
            "is-toolbar": true,
            style: {"justify-content":"flex-start","align-items":"start"}
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(_shoppingCartStore).getCurrentItem().shoppingCartItem.insuranceExportBlanks, (blank) => {
                return (_openBlock(), _createBlock(SogCardActionButton, {
                  key: blank,
                  onClick: ($event: any) => (onRemoveExportBlank(blank))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(blank.insuranceNumber), 1),
                    _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
                    _createTextVNode(_toDisplayString(blank.blankNumber), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["style"])
    ]),
    _: 1
  }))
}
}

})